import { Component } from "@angular/core";
import { TestAuth } from "../../../services/TestAuth";

@Component({
  selector: "test-events-index",
  templateUrl: "./TestEventsIndexCmp.html",
  styleUrls: ["./TestEventsIndexCmp.css"],
})
export class TestEventsIndexCmp {
  constructor(public testAuth: TestAuth) {}
}
